import React, { useContext, useMemo } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CreateUnitModalContent from './CreateUnitModalContent';
import { Modalv2Context } from '../../../../Contexts/Modalv2Context';
import { Box } from '@mui/system';
import useStyles from './styles';

import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import DropDownSingle from '../../../../Components/DropDownSingle';

const CreateVideoSectionUI = () => {
	const { updateModalContent } = useContext(Modalv2Context);
	const classes = useStyles();

	return (
		<Box className={classes.VideoSectionSelector}>
			<DropDown label="Unit Id" />
			<AddCircleIcon
				className={classes.icon}
				color="primary"
				fontSize="medium"
				style={{ margin: '2rem' }}
				onClick={() => {
					updateModalContent(<CreateUnitModalContent />);
				}}
			/>
		</Box>
	);
};

const DropDown = () => {
	const { updateCurSelectedId, curSelectedId, fvpConfig } = useContext(FvpConfigContext);

	const videoSectionDropDownList = useMemo(() => {
		if (fvpConfig) {
			return Object.keys(fvpConfig?.ads).map((id) => {
				const videoSection = fvpConfig.ads[id];
				return {
					label: `${videoSection.videoSectionName} (${videoSection.videoSectionId})`,
					value: videoSection.videoSectionId
				};
			});
		} else {
			return [];
		}
	}, [fvpConfig]);

	return (
		<DropDownSingle
			system={ACCESS_CONTROL_CONSTANTS.SYSTEMS.FVP_PLAYER}
			isObjectEditor={false}
			keyData={'ads.videoSectionIds'}
			list={videoSectionDropDownList}
			formControlVariant="outlined"
			containerStyles={{ marginTop: '1rem' }}
			selectInputStyles={{ width: '50rem' }}
			directValue={curSelectedId}
			updateDirectValue={(Id) => {
				updateCurSelectedId(Id);
			}}
		/>
	);
};

export default CreateVideoSectionUI;
